import { Injectable, Renderer2, RendererFactory2 } from "@angular/core";
import { Router } from "@angular/router";
import { AppConfig } from "../configs/app";
import { CommonService } from "../services/common.service";
import { CartService } from "../services/cart.service";
import { UserService } from "../services/user.service";
import { AuthService } from "../services/auth.service";
import { AffiliateService } from "./affiliate.service";
import { AnalyticsService } from "./analytics.service";

@Injectable({
  providedIn: "root",
})
export class ReservationService {
  public moment: any;
  public _: any;
  private renderer: Renderer2;

  constructor(
    public appConfig: AppConfig,
    public router: Router,
    public commonService: CommonService,
    public cartService: CartService,
    public userService: UserService,
    private affiliateService: AffiliateService,
    public authService: AuthService,
    private rendererFactory: RendererFactory2,
    private analyticsService: AnalyticsService
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
    this.moment = this.commonService.getMoment();
    this._ = this.commonService.getLodash();
  }

  async getSeatMapData(paramString: any) {
    let params = {
      url: this.appConfig.busAPIBaseURL + "reserve/inquirySeatmap",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
        params: paramString,
      },
    };

    let returnData = await this.commonService.sendHTTPGet(params);

    if (returnData.status == "success") {
      return returnData.data;
    }

    return {};
  }

  async changeReservation(data: any) {
    let postString = this.commonService.objectToString(data);
    let params = {
      url: this.appConfig.busAPIBaseURL + "reserve/changeReserve",
      data: `${postString}`,
      options: {
        headers: this.commonService.getHTTPBusHeader(),
      },
    };

    let returnData = await this.commonService.sendHTTPPost(params);

    return returnData;
  }

  makeReservationChangeData(
    reservationData: any,
    changeData: any = {},
    isCancelled: boolean = false
  ) {
    /* DEEP COPIES */
    reservationData = JSON.parse(JSON.stringify(reservationData));
    changeData = JSON.parse(JSON.stringify(changeData));
    /* END */

    let returnData: any = {};

    if (reservationData) {
      returnData = {
        reservation_id: reservationData.reservation.reservation_id,

        dpt_station_code_1:
          reservationData.reservation.station_list[0].station_code,
        dpt_man_1:
          reservationData.reservation.passenger.adult.men +
          reservationData.reservation.passenger.children.men,
        dpt_woman_1:
          reservationData.reservation.passenger.adult.women +
          reservationData.reservation.passenger.children.women,
        dst_station_code_1:
          reservationData.reservation.station_list[1].station_code,
        dst_man_1:
          reservationData.reservation.passenger.adult.men +
          reservationData.reservation.passenger.children.men,
        dst_woman_1:
          reservationData.reservation.passenger.adult.women +
          reservationData.reservation.passenger.children.women,
      };

      if (!isCancelled) {
        returnData.dpt_man_1 = 0;
        returnData.dpt_woman_1 = 0;
        returnData.dst_man_1 = 0;
        returnData.dst_woman_1 = 0;
      }

      /* PASSENGER DATA */
      let passengers = {};

      for (let [
        index,
        passenger,
      ] of reservationData.reservation.passenger_list.entries()) {
        let idx = index + 1;

        passengers[`p_sei_${idx}`] = passenger.sei_kana;
        passengers[`p_mei_${idx}`] = passenger.mei_kana;
        passengers[`p_sex_${idx}`] = passenger.sex;
        passengers[`p_age_${idx}`] = passenger.age;
        passengers[`p_tel1_${idx}`] = passenger.tel1;
        passengers[`p_tel2_${idx}`] = passenger.tel2;
        passengers[`p_tel3_${idx}`] = passenger.tel3;

        /* BOARDING */
        if (this._.isEmpty(changeData)) {
          passengers[`p_board_${idx}`] =
            isCancelled ||
            passenger.board ==
              this.commonService.appConfig.reservation.passengerBoarding
                .cancelled
              ? 0
              : 1;
        } else {
          passengers[`p_board_${idx}`] =
            isCancelled ||
            changeData[`p_board_${idx}`] ==
              this.commonService.appConfig.reservation.passengerBoarding
                .cancelled
              ? 0
              : 1;
          delete changeData[`p_board_${idx}`];
        }
        /* END */

        /* RE-COUNT NUMBER OF PASSENGERS */
        if (!isCancelled) {
          if (
            passengers[`p_board_${idx}`] ==
            this.commonService.appConfig.reservation.passengerBoarding.boarding
          ) {
            if (
              passengers[`p_sex_${idx}`] ==
              this.commonService.appConfig.reservation.defaultUserData.sexFemale
            ) {
              returnData.dpt_woman_1++;
              returnData.dst_woman_1++;
            } else {
              returnData.dpt_man_1++;
              returnData.dst_man_1++;
            }
          }
        }
        /* END */

        passengers[`p_representative_${idx}`] = index === 0 ? 1 : 0;
      }
      returnData = { ...returnData, ...passengers };

      /* MERGE changeData INTO MASTER DATA*/
      returnData = { ...returnData, ...changeData };

      /* AUTH TOKEN (PUBLIC SEARCH) */
      if (reservationData.reservation.auth_token) {
        returnData["auth_token"] = reservationData.reservation.auth_token;
      }
    }

    return returnData;
  }

  async calculationPriceChanges(data: any) {
    let postString = this.commonService.objectToString(data);
    let params = {
      url: this.appConfig.busAPIBaseURL + "reserve/calculationChangePrice",
      data: `${postString}`,
      options: {
        headers: this.commonService.getHTTPBusHeader(),
      },
    };

    let returnData = await this.commonService.sendHTTPPost(params);

    return returnData;
  }

  async createReservationData(type: any = null) {
    let cartData = this.cartService.getCartData();
    let userList: any = await this.getPassengerData();

    let cUser = {
      c_sei: "",
      c_mei: "",
      c_sex: this.commonService.appConfig.reservation.defaultUserData.sexMale,
      c_birthday: "",
      c_tel1: "",
      c_tel2: "",
      c_tel3: "",
      c_tel: "",
      c_coty_id: "1",
      c_mail: "",
      c_mail2: "",
      payment_method: 0,
    };
    let profileData: any;
    if (this.authService.isLoggedIn()) {
      profileData = await this.userService.getProfileInfo();
      cUser = {
        c_sei: profileData.sei ? profileData.sei : "",
        c_mei: profileData.mei ? profileData.mei : "",
        c_sex:
          profileData.sex_type && profileData.sex_type != "0"
            ? parseInt(profileData.sex_type)
            : this.commonService.appConfig.reservation.defaultUserData.sexMale,
        c_birthday: userList[0].primary.birthday
          ? userList[0].primary.birthday
          : "",
        c_tel1: profileData.tel1,
        c_tel2: profileData.tel2,
        c_tel3: profileData.tel3,
        c_tel: profileData.tel ? profileData.tel : "",
        c_coty_id:
          profileData.pref_id && profileData.pref_id != "0"
            ? profileData.pref_id
            : "1",
        c_mail: profileData.email1 ? profileData.email1 : "",
        c_mail2: profileData.email2 ? profileData.email2 : "",
        payment_method: 0,
      };
    }

    if (type == this.appConfig.reservation.registerWithBooking) {
      cUser["bookingWithRegistering"] =
        this.appConfig.reservation.registerWithBookingOn;
      cUser["register_with_booking"] =
        this.appConfig.reservation.registerWithBookingOn;
    } else {
      cUser["bookingWithRegistering"] =
        this.appConfig.reservation.registerWithBookingOff;
    }

    let cartParam: any = {};

    for (let [index, item] of cartData.entries()) {
      cartParam[index + 1 + "_plan_code"] = item.plan.plan_code;
      cartParam[index + 1 + "_booking_id"] = this.moment.now();
      cartParam[index + 1 + "_dpt_ymd"] = this.moment(item.targetDay).format(
        "YYYYMMDD"
      );
      cartParam[index + 1 + "_dpt_man_1"] =
        item.passenger.adult.men + item.passenger.children.men;
      cartParam[index + 1 + "_dpt_woman_1"] =
        item.passenger.adult.women + item.passenger.children.women;
      cartParam[index + 1 + "_dpt_station_code_1"] =
        item.plan.station_list[item.departure].station_code;
      cartParam[index + 1 + "_dst_man_1"] =
        item.passenger.adult.men + item.passenger.children.men;
      cartParam[index + 1 + "_dst_woman_1"] =
        item.passenger.adult.women + item.passenger.children.women;
      cartParam[index + 1 + "_dst_station_code_1"] =
        item.plan.station_list[item.destination].station_id;
    }

    let userParam: any = {};

    for (let [index, item] of userList.entries()) {
      item.list.forEach(function (user: any, y) {
        userParam[index + 1 + "_p_sei_" + (y + 1)] = user.sei;
        userParam[index + 1 + "_p_mei_" + (y + 1)] = user.mei;
        userParam[index + 1 + "_p_sex_" + (y + 1)] = parseInt(user.sex);
        userParam[index + 1 + "_p_age_" + (y + 1)] = user.age;
        userParam[index + 1 + "_p_birth_date_" + (y + 1)] = "";
        userParam[index + 1 + "_p_tel1_" + (y + 1)] = user.tel1;
        userParam[index + 1 + "_p_tel2_" + (y + 1)] = user.tel2;
        userParam[index + 1 + "_p_tel3_" + (y + 1)] = user.tel3;
        userParam[
          index + 1 + "_p_tel_" + (y + 1)
        ] = `${user.tel1}${user.tel2}${user.tel3}`;
        userParam[index + 1 + "_price_type_" + (y + 1)] = user.price_type;
      });
    }

    /* ASSIGN AFFILIATE CODE */
    let acdCode = this.affiliateService.getAcdCode();
    if (acdCode) {
      cUser["acd_code"] = acdCode.code;
    }

    let postObject = Object.assign(cUser, userParam, cartParam);
    this.saveReservationData(postObject);
    this.analyticsService.beginCheckout(
      cartData,
      this.authService.isLoggedIn()
    );
  }

  prepareDataBooking(data: any) {
    let res = Object.assign({}, data);
    delete res.goToInsurancePage;
    delete res.chubbInsuranceHidden;
    return res;
  }

  async proceedToBooking(data: any) {
    /* CHECK PAYMENT METHOD */
    const busSettings = this.commonService.getData(
      this.commonService.appConfig.site.settingSessionName
    );
    const paymentType = this.appConfig.reservation.paymentType;
    const availablePaymentMethods = {};
    availablePaymentMethods[paymentType.creditCard] = true;
    availablePaymentMethods[paymentType.bank] = true;
    availablePaymentMethods[paymentType.postpay] =
      this._.get(busSettings, "payment.postpay.available") == 1;
    availablePaymentMethods[paymentType.paypay] =
      this._.get(busSettings, "payment.paypay.available") == 1;
    availablePaymentMethods[paymentType.paidy] =
      this._.get(busSettings, "payment.paidy.available") == 1;
    if (!availablePaymentMethods[data.payment_method]) {
      return {
        status: "fail",
        data: {
          info: "お支払い方法が正しく選択されていません。もう一度お選びください。",
        },
      };
    }
    /* END */

    const bookingData = this.prepareDataBooking(data);
    delete bookingData.referer;
    let postString = this.commonService.objectToString(bookingData);
    let params = {};
    // let returnData = {};
    if (
      data.payment_method == this.appConfig.reservation.paymentType.bank ||
      data.payment_method == this.appConfig.reservation.paymentType.paidy
    ) {
      params = {
        url: this.appConfig.busAPIBaseURL + "reserve/createReserve",
        data: `${postString}`,
        options: {
          headers: this.commonService.getHTTPBusHeader(),
        },
      };

      let returnData = await this.commonService.sendHTTPPost(params);
      return returnData;
    } else if(data.payment_method == this.appConfig.reservation.paymentType.creditCard) {
      // [CR-FRONT-06] クレジットカード3D Secure決済
      //
      // バックエンド(ReserveController.php L2227-2229)はクレジットカードの場合、
      // JSONではなく echo で生HTMLを直接返す（Veritrans 3D認証画面）。
      // そのため responseType: 'text' でリクエストし、HTMLを受け取って
      // insertAndSubmitForm()でDOMに挿入→3D認証画面を表示する。

      if (localStorage.getItem(this.appConfig.auth.loginSessionName) !== null) {
        let userData = JSON.parse(localStorage.getItem(this.appConfig.auth.loginSessionName));
        postString += '&customer_id=' + `${userData.userData.id}`;
      }

      const response: any = await this.commonService.httpClient
        .post(
          this.appConfig.busAPIBaseURL + "reserve/createReserve",
          postString,
          {
            headers: this.commonService.getHTTPBusHeader(),
            responseType: 'text' as 'json'
          }
        )
        .toPromise()
        .catch(function (err) {
          console.log(err);
          return null;
        });

      if (response && typeof response === 'string' && response.toLowerCase().includes('<form')) {
        this.insertAndSubmitForm(response);
        return;
      }
      // HTMLが返されなかった場合はエラーとして呼び出し元に返す
      return { status: "fail", data: { info: "3Dセキュア認証画面の取得に失敗しました" } };
    } else {
      params = {
        url: this.appConfig.busAPIBaseURL + "reserve/paypay",
        data: `${postString}`,
        options: {
          headers: this.commonService.getHTTPBusHeader(),
        },
      };

      if (localStorage.getItem(this.appConfig.auth.loginSessionName) !== null) {
        let userData = JSON.parse(
          localStorage.getItem(this.appConfig.auth.loginSessionName)
        );
        // window.location.href =
        //   this.appConfig.busAPIBaseURL +
        //   "reserve/paypay" +
        //   "?" +
        //   `${postString}` +
        //   "&id=" +
        //   `${userData.userData.id}`;
      } else {
        // window.location.href =
        //   this.appConfig.busAPIBaseURL +
        //   "reserve/paypay" +
        //   "?" +
        //   `${postString}`;
      }
      // window.location.href = 'http://local.busbookmark.jp'+this.commonService.routePaths.pageReservePaypay+'?plan_id='+data['1_plan_code'];
    }

    const response = await this.commonService.sendHTTPPost(params);
    const response_html = this._.get(response, "data.response_html");
    if (!response_html) {
      return {
        status: "fail",
        data: {
          info: "お支払い手続きを開始できませんでした。お手数ですが、お支払い方法をお選び直しください。",
        },
      };
    }
    this.insertAndSubmitForm(response_html);

    // return returnData;
  }

  async getRedirectBooking(data: any) {
    let params = {};
    let returnData = {};
    if (data) {
      let session_name = {
        session_name: data,
      };
      let postString = this.commonService.objectToString(session_name);
      params = {
        url: this.appConfig.busAPIBaseURL + "reserve/getRedirectReserveData",
        data: `${postString}`,
        options: {
          headers: this.commonService.getHTTPBusHeader(),
        },
      };
      returnData = await this.commonService.sendHTTPPost(params);
    }

    return returnData;
  }

  getReservationData() {
    return this.commonService.getData(
      this.appConfig.reservation.reservationDataSessionName
    );
  }

  saveReservationData(reservationData: any) {
    if (reservationData) {
      this.commonService.setData(
        this.appConfig.reservation.reservationDataSessionName,
        reservationData
      );
    }
  }

  getInsuranceData() {
    return this.commonService.getData(
      this.appConfig.reservation.insuranceDataSessionName
    );
  }

  getInsuranceToken() {
    return this.commonService.getData(
      this.appConfig.reservation.insuranceTokenSessionName
    );
  }

  saveInsuranceData(insuranceData: any) {
    if (insuranceData) {
      this.commonService.setData(
        this.appConfig.reservation.insuranceDataSessionName,
        insuranceData
      );
    }
  }

  saveInsuranceToken(insuranceToken: any) {
    if (insuranceToken) {
      this.commonService.setData(
        this.appConfig.reservation.insuranceTokenSessionName,
        insuranceToken
      );
    }
  }

  savePassengerData(passengerData: any) {
    if (passengerData) {
      this.commonService.setData(
        this.appConfig.reservation.passengerSessionName,
        passengerData
      );
    }
  }

  saveInsurancePassengerData1(insurancePassengerData: any) {
    if (insurancePassengerData) {
      this.commonService.setData(
        this.appConfig.reservation.insurancePassengerData1SessionName,
        insurancePassengerData
      );
    }
  }

  getInsurancePassengerData1() {
    return this.commonService.getData(
      this.appConfig.reservation.insurancePassengerData1SessionName
    );
  }

  saveReservationCompleteData(data: any) {
    if (data) {
      this.commonService.setData(
        this.appConfig.reservation.reservationCompleteDataSessionName,
        data
      );
    }
  }

  getReservationCompleteData() {
    return this.commonService.getData(
      this.appConfig.reservation.reservationCompleteDataSessionName
    );
  }

  savePaymentCalcData(data: any) {
    if (data) {
      this.commonService.setData(
        this.appConfig.reservation.paymentCalculationDataSessionName,
        data
      );
    }
  }

  getPaymentCalcData() {
    return this.commonService.getData(
      this.appConfig.reservation.paymentCalculationDataSessionName
    ) || {};
  }

  saveCouponData(data: any) {
    if (data) {
      this.commonService.setData(
        this.appConfig.reservation.couponDataName,
        data
      );
    }
  }

  getCouponData() {
    return this.commonService.getData(
      this.appConfig.reservation.couponDataName
    );
  }

  async getPassengerData() {
    let returnData = [];

    let loggedUserInfo: any = {
      customerID: "",
      cotyID: "",
      sei: "",
      mei: "",
      sex: "",
      birthday: "",
      tel1: "",
      tel2: "",
      tel3: "",
      tel: "",
      mail: "",
    };

    if (this.authService.isLoggedIn()) {
      /* LOGGED IN */
      let userData = await this.userService.getProfileInfo();

      loggedUserInfo.customerID = userData.id;
      loggedUserInfo.cotyID = userData.pref_id;
      loggedUserInfo.sei = userData.sei;
      loggedUserInfo.mei = userData.mei;
      loggedUserInfo.sex = parseInt(userData.sex_type);
      loggedUserInfo.birthday = userData.birth_date
        ? userData.birth_date.replace(/-/g, "")
        : userData.birth_date;
      loggedUserInfo.tel1 = userData.tel1;
      loggedUserInfo.tel2 = userData.tel2;
      loggedUserInfo.tel3 = userData.tel3;
      loggedUserInfo.tel = userData.tel ? userData.tel : loggedUserInfo.tel;
      loggedUserInfo.mail = userData.email1;
      loggedUserInfo.age = this.moment().diff(userData.birth_date, "years");
    } else {
      let reservationData = this.getReservationData();

      if (reservationData) {
        loggedUserInfo.sei = reservationData.c_sei;
        loggedUserInfo.mei = reservationData.c_mei;
        loggedUserInfo.sex = parseInt(reservationData.c_sex);
        loggedUserInfo.birthday = reservationData.c_birthday
          ? reservationData.c_birthday.replace(/-/g, "")
          : reservationData.c_birthday;
        loggedUserInfo.tel1 = reservationData.c_tel1;
        loggedUserInfo.tel2 = reservationData.c_tel2;
        loggedUserInfo.tel3 = reservationData.c_tel3;
        loggedUserInfo.tel = reservationData.c_tel;
        loggedUserInfo.mail = reservationData.c_mail;
        loggedUserInfo.age = this.moment().diff(
          reservationData.c_birthday,
          "years"
        );
      }
    }

    let cartData = this.cartService.getCartData();

    if (cartData) {
      for (let item of cartData) {
        /* PRIMARY */
        let insertingItem = {
          primary: {
            planCode: item.plan.plan_code,
            dpt_ymd: this.moment(item.targetDay).format("YYYYMMDD"),
            dpt_station_code:
              item.plan.station_list[item.departure].station_code,
            dpt_man: item.passenger.adult.men + item.passenger.children.men,
            dpt_woman:
              item.passenger.adult.women + item.passenger.children.women,
            dst_station_code:
              item.plan.station_list[item.destination].station_code,
            dst_man: item.passenger.adult.men + item.passenger.children.men,
            dst_woman:
              item.passenger.adult.women + item.passenger.children.women,
            ...loggedUserInfo,
          },
          list: [],
        };

        /* PASSENGER */
        /* ADULT MEN */
        for (let i = 0; i < item.passenger.adult.men; i++) {
          insertingItem.list.push({
            sei: "",
            mei: "",
            sex: 1,
            age: "",
            tel1: "",
            tel2: "",
            tel3: "",
            price_type: 1,
          });
        }
        /* ADULT WOMEN */
        for (let i = 0; i < item.passenger.adult.women; i++) {
          insertingItem.list.push({
            sei: "",
            mei: "",
            sex: 2,
            age: "",
            tel1: "",
            tel2: "",
            tel3: "",
            price_type: 1,
          });
        }

        /* CHILDREN MEN */
        for (let i = 0; i < item.passenger.children.men; i++) {
          insertingItem.list.push({
            sei: "",
            mei: "",
            sex: 1,
            age: "",
            tel1: "",
            tel2: "",
            tel3: "",
            price_type: 2,
          });
        }
        /* CHILDREN WOMEN */
        for (let i = 0; i < item.passenger.children.women; i++) {
          insertingItem.list.push({
            sei: "",
            mei: "",
            sex: 2,
            age: "",
            tel1: "",
            tel2: "",
            tel3: "",
            price_type: 2,
          });
        }

        /* SET THE FIRST PERSON HAS PRIMARY PERSON INFO */
        insertingItem.list[0] = { ...insertingItem.list[0], ...loggedUserInfo };

        returnData.push(insertingItem);
      }
    }

    return returnData;
  }

  removeReservationData() {
    this.commonService.removeBatchData([
      this.appConfig.cart.cartSessionName,
      this.appConfig.cart.serchSessionName,
      this.appConfig.reservation.insuranceDataSessionName,
      this.appConfig.reservation.passengerSessionName,
      this.appConfig.reservation.reservationCompleteDataSessionName,
      this.appConfig.reservation.reservationDataSessionName,
      this.appConfig.reservation.couponDataName,
    ]);
  }

  async searchAddressByZipCode(paramString: any) {
    let params = {
      url: this.appConfig.busAPIBaseURL + "reserve/searchAddressByZipCode",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
        params: paramString,
      },
    };

    let returnData = await this.commonService.sendHTTPGet(params);

    if (returnData.status == "success") {
      return returnData.data;
    }

    return [];
  }

  async calculateTotalAmount(
    cartData: any,
    insuranceData: any,
    priceCalculation: any,
    postData: any,
    couponData: any,
    listUser: any,
    userList: any,
    seatData: any
  ) {
    /* GET BUS SETTINGS */
    let busSettings = this.commonService.getData(
      this.commonService.appConfig.site.settingSessionName
    );

    if (this._.isEmpty(cartData)) {
      cartData = this.cartService.getCartData();
    }
    if (this._.isEmpty(insuranceData)) {
      insuranceData = this.getInsuranceData();
    }
    if (!priceCalculation) {
      priceCalculation = {};
    }
    if (this._.isEmpty(postData)) {
      postData = this.getReservationData();
    }
    if (this._.isEmpty(userList)) {
      userList = await this.getPassengerData();
    }
    if (!this._.isEmpty(userList) && this._.isEmpty(listUser)) {
      listUser = userList[0].list;
    }

    let totalCartPrice = 0;
    for (let cartPrice of cartData) {
      totalCartPrice += cartPrice.totalPrice;
    }
    priceCalculation.ticketPrice = totalCartPrice;

    if (insuranceData && insuranceData.insurancePrice) {
      totalCartPrice += insuranceData.insurancePrice;
      priceCalculation.insurancePrice = insuranceData.insurancePrice;
    } else {
      priceCalculation.insurancePrice = 0;
    }

    if (
      insuranceData &&
      insuranceData.zurich &&
      insuranceData.zurich.insurancePrice
    ) {
      // update zurich.insurancePrice
      insuranceData.zurich.insurancePrice = cartData
        .map((x) => this.calcZurichInsurancePrice(x.totalPrice))
        .reduce((x, y) => x + y);
      totalCartPrice += insuranceData.zurich.insurancePrice;
      priceCalculation.zurichInsurancePrice =
        insuranceData.zurich.insurancePrice;
      // calc for each reservation
      if (cartData.length > 1) {
        priceCalculation.zurichPriceDetail = cartData
          .map((val, index) => {
            return (
              index +
              1 +
              "便目：" +
              this.commonService.formatCurrency(
                this.calcZurichInsurancePrice(val.totalPrice)
              ) +
              "円"
            );
          })
          .join(" ");
      }
    } else {
      priceCalculation.zurichInsurancePrice = 0;
    }

    /* COUPON DATA */
    if (postData.use_coupon) {
      couponData = this.getCouponData();
      couponData.discountDisplay = Math.abs(couponData.discount);
      totalCartPrice -= parseInt(couponData.discount);
    }

    priceCalculation.totalCartPrice = totalCartPrice;

    /* SEAT PRICE DATA */
    let seatCounter: any = {};

    for (let i = 0; i < listUser.length; i++) {
      let seatPrice = postData[`1_p_seat_price_${i + 1}`];
      if (seatPrice) {
        if (seatCounter.hasOwnProperty(seatPrice)) {
          seatCounter[seatPrice]++;
        } else {
          seatCounter[seatPrice] = 1;
        }
      }
    }

    if (cartData.length == 2) {
      let listUser2 = userList[1].list;
      for (let i = 0; i < listUser2.length; i++) {
        let seatPrice = postData[`2_p_seat_price_${i + 1}`];
        if (seatPrice) {
          if (seatCounter.hasOwnProperty(seatPrice)) {
            seatCounter[seatPrice]++;
          } else {
            seatCounter[seatPrice] = 1;
          }
        }
      }
    }

    let tempData = [];
    let seatTotalPrice = 0;
    for (let price in seatCounter) {
      tempData.push({
        price: price,
        counts: seatCounter[price],
      });
      seatTotalPrice += parseFloat(price) * parseFloat(seatCounter[price]);
    }

    seatCounter = tempData;
    seatData = seatCounter;

    if (seatTotalPrice != 0) {
      priceCalculation.seatTotalPrice = seatTotalPrice;
      priceCalculation.totalCartPrice += priceCalculation.seatTotalPrice;
    }
    /* END OF SEAT DATA */

    /* POSTPAY */
    if (
      postData.payment_method == this.appConfig.reservation.paymentType.postpay
    ) {
      /* REVERT COUPON */
      priceCalculation.totalCartPrice += postData.use_coupon
        ? parseInt(couponData.discount)
        : 0;

      /* ADD X% TO TOTAL AMOUNT */
      priceCalculation.postpayPriceSum = priceCalculation.totalCartPrice;
      priceCalculation.postpayExtraFee =
        priceCalculation.totalCartPrice * busSettings.payment.postpay.rate;
      if (
        priceCalculation.postpayExtraFee <
        busSettings.payment.postpay.minCommissionAmount
      ) {
        priceCalculation.postpayExtraFee =
          busSettings.payment.postpay.minCommissionAmount;
      }
      priceCalculation.totalCartPrice =
        priceCalculation.totalCartPrice + priceCalculation.postpayExtraFee;

      /* APPLY COUPON */
      priceCalculation.totalCartPrice -= postData.use_coupon
        ? parseInt(couponData.discount)
        : 0;
    }

    /* bank */
    if (postData.payment_method == this.appConfig.reservation.paymentType.bank) {
      /* REVERT COUPON */
      priceCalculation.totalCartPrice += (postData.use_coupon ? parseInt(couponData.discount) : 0);

      /* ADD X% TO TOTAL AMOUNT */
      priceCalculation.bankPriceSum = priceCalculation.totalCartPrice;
      priceCalculation.bankExtraFee = busSettings.payment.cvs.extraFee;
      priceCalculation.totalCartPrice = priceCalculation.totalCartPrice + priceCalculation.bankExtraFee;

      /* APPLY COUPON */
      priceCalculation.totalCartPrice -= (postData.use_coupon ? parseInt(couponData.discount) : 0);
    }

    return {
      priceCalculation: priceCalculation,
      couponData: couponData,
      seatData: seatData,
    };
  }

  /* MY PAGES FUNCTIONS BELOW */
  async getReservationList(searchParams: any) {
    let returnData = {
      list: [],
      totalReservations: 0,
    };

    let params = {
      url: this.appConfig.busAPIBaseURL + "reserve/getReservationList",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
        params: searchParams,
      },
    };

    let returnedData = await this.commonService.sendHTTPGet(params);

    if (returnedData.status == "success") {
      returnData.list = returnedData.data.reservation_list;
      returnData.totalReservations = returnedData.data.reservation_counts;
    } else {
      console.log(returnedData.message);
    }

    return returnData;
  }

  async getReservationDetails(searchParams: any) {
    let returnData = {
      reservation: {},
      userData: {},
    };

    let params = {
      url: this.appConfig.busAPIBaseURL + "reserve/getReservationDetails",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
        params: {
          reservation_id: searchParams.reservationID,
          bus_detail: searchParams.busDetail,
          mail_detail: searchParams.emailDetail,
        },
      },
    };

    let returnedData = await this.commonService.sendHTTPGet(params);

    if (returnedData.status == "success") {
      if (!this._.isEmpty(returnedData.data.reservation_list)) {
        returnData.reservation = returnedData.data.reservation_list[0];
        returnData.userData = returnedData.data.customer;
        returnData.reservation["auth_token"] = returnedData.data.auth_token;
      }
    } else {
      console.log(returnedData.message);
    }

    return returnData;
  }

  async findReservationByID(searchParams: any) {
    let returnData = {
      reservation: {},
      userData: {},
    };

    let params = {
      url: this.appConfig.busAPIBaseURL + "reserve/findReservationByID",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
        params: {
          reservation_id: searchParams.reservationID,
          tel: searchParams.tel,
          bus_detail: searchParams.busDetail,
          mail_detail: searchParams.emailDetail,
        },
      },
    };

    let returnedData = await this.commonService.sendHTTPGet(params);

    if (returnedData.status == "success") {
      if (!this._.isEmpty(returnedData.data.reservation_list)) {
        returnData.reservation = returnedData.data.reservation_list[0];
        /* AUTH TOKEN (PUBLIC SEARCH) */
        if (returnedData.data.auth_token) {
          returnData.reservation["auth_token"] = returnedData.data.auth_token;
        }
        returnData.userData = returnedData.data.customer;

        /* SAVE DATA TO NEXT PAGE */
        this.commonService.setData("searchReservationParams", searchParams);
        this.commonService.setData("searchReservationDataDetail", returnData);
        this.commonService.setData("searchReservationDataEmail", returnData);
        /* TODO */
      }
    } else {
      console.log(returnedData.message);
    }

    return returnData;
  }

  async getReceiptList(searchParams: any) {
    let returnData = {
      receipt_list: [],
      totalReceipt: 0,
    };

    let params = {
      url: this.appConfig.busAPIBaseURL + "reserve/getReceiptList",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
        params: {
          offset: searchParams.offset,
          limit: searchParams.limit,
        },
      },
    };

    let returnedData = await this.commonService.sendHTTPGet(params);

    if (returnedData.status == "success") {
      returnData.receipt_list = returnedData.data.receipt_list;
      returnData.totalReceipt = returnedData.data.reservation_counts_total;
    } else {
      console.log(returnedData.message);
    }

    return returnData;
  }

  getPaymentDay(secPay: any, boardDate: any) {
    let paymentLimitDay = "";
    boardDate = boardDate ? boardDate.replace(/[-/]/g, "") : boardDate;
    boardDate = this.moment(boardDate).format("YYYY-MM-DD");
    if (secPay == this.commonService.appConfig.reservation.paymentType.bank) {
      //コンビニ払い：入金期限計算
      let today = this.moment().format("YYYY-MM-DD");
      let weekLater = this.moment(today).add(8, "days").format("YYYY-MM-DD");
      //当日
      if (boardDate == today) {
        paymentLimitDay = today;
        //1週間以内
      } else if (boardDate < weekLater) {
        paymentLimitDay = this.moment(today)
          .add(1, "days")
          .format("YYYY-MM-DD");
        //1週間以上
      } else if (boardDate >= weekLater) {
        paymentLimitDay = this.moment(today)
          .add(2, "days")
          .format("YYYY-MM-DD");
      }
      if (paymentLimitDay != "") {
        paymentLimitDay += " 22:00:00";
      }
    } else {
      //クレジット
      paymentLimitDay = this.moment().format("YYYY-MM-DD");
      paymentLimitDay += " 22:00:00";
    }
    return paymentLimitDay;
  }

  generatePDF(data: any) {
    let dataUrl = this.commonService.b64EncodeUnicode(JSON.stringify(data));
    let url =
      this.commonService.appConfig.busAPIBaseURL +
      "reserve/generatePDF?data=" +
      dataUrl;
    window.open(url);
  }

  async getCancelInformation(data: any) {
    let params = {
      url: this.appConfig.busAPIBaseURL + "reserve/calculationChangePrice",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
        params: {
          reservation_id: data.reservation_id,
          cancel_type: data.cancel_type,
          change_board: data.change_board,
          auth_token: data.auth_token,
        },
      },
    };
    let returnData = await this.commonService.sendHTTPGet(params);
    if (returnData.status == "success") {
      return returnData.data;
    } else {
      console.log(returnData.message);
      return {};
    }
  }

  saveReservationChangesData(reservationChangesData: any) {
    if (reservationChangesData) {
      this.commonService.setData(
        this.appConfig.reservation.changeReservationDataSessionName,
        reservationChangesData
      );
    }
  }

  getReservationChangesData() {
    return this.commonService.getData(
      this.appConfig.reservation.changeReservationDataSessionName
    );
  }

  async couponChecking(couponName: any) {
    let params = {
      url: this.appConfig.busAPIBaseURL + "reserve/checkCouponValid",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
        params: {
          coupon_code: couponName,
        },
      },
    };

    let returnData = await this.commonService.sendHTTPGet(params);

    return returnData;
  }

  getMinAgeByOfficeCode(officeCode: any = null) {
    if (
      officeCode &&
      this.appConfig.reservation.planAgeLimit.hasOwnProperty(officeCode)
    ) {
      return this.appConfig.reservation.planAgeLimit[officeCode].min;
    }
    return this.appConfig.reservation.passengerAgeLimit.min;
  }

  /* ZURICH UTILITY FUNCTIONS START */
  calcZurichInsurancePrice(ticketPrice: number) {
    let price =
      10 *
      Math.round(
        (ticketPrice * this.appConfig.reservation.zurichInsuranceRate) / 10
      );
    price = Math.max(price, 10);
    return price;
  }

  /**
   * Conditions: The ticket holder must be at least 20 years old;
   *   and booking dates must be at least 2 days prior to boarding date;
   *   and unit price (adult & child) must be equal or greater than 2500
   *   and the total number of people in each trip is less than 21.
   * @param departureDay: 'YYYYMMDD';
   * @param customerBirthday: 'YYYYMMDD';
   * @param cartData: from CartService->getCartData to get total people.
   */
  isNeedHideZurich(departureDay: any, customerBirthday: any, cartData: any) {
    return true;
    // The ticket holder must be at least 20 years old;
    const age = this.moment().diff(
      this.moment(customerBirthday, "YYYYMMDD").format("YYYY-MM-DD"),
      "years"
    );
    if (age < 20) {
      return true;
    }
    // the total number of people in each trip is less than 21;
    for (const item of cartData) {
      const total =
        item.passenger.adult.men +
        item.passenger.children.men +
        item.passenger.adult.women +
        item.passenger.children.women;
      if (total > 20) {
        return true;
      }
    }

    /* GET BUS SETTINGS */
    const busSettings = this.commonService.getData(
      this.commonService.appConfig.site.settingSessionName
    );
    for (const cart of cartData) {
      if (
        cart.passenger.adult.total > 0 &&
        cart.plan.price < busSettings.insurance.zurich.minTicketPrice
      ) {
        return true;
      }
      if (
        cart.passenger.children.total > 0 &&
        cart.plan.price_child < busSettings.insurance.zurich.minTicketPrice
      ) {
        return true;
      }
    }

    // booking dates must be at least 2 days prior to boarding date;
    const dayBeforeDepartureDay = this.moment(departureDay)
      .startOf("day")
      .diff(this.moment(Date.now()).startOf("day"), "days");
    return dayBeforeDepartureDay < 2;
  }
  /* ZURICH UTILITY FUNCTIONS END*/

  getMaxAgeOfReservations(reservationData: any) {
    let maxAge = 0; /* THE DEFAULT IS 0 */
    if (!this._.isEmpty(reservationData)) {
      for (let tripNo = 1; tripNo < 3; tripNo++) {
        for (let personNo = 1; personNo < 37; personNo++) {
          let age = parseInt(reservationData[`${tripNo}_p_age_${personNo}`]);
          if (age && age > maxAge) {
            maxAge = age;
          }
        }
      }
    }

    return maxAge;
  }

  checkChuBbMaxAge(reservationData: any) {
    let maxAge = this.getMaxAgeOfReservations(reservationData);
    if (maxAge > this.appConfig.reservation.insuranceChuBbMaxAge) {
      //90歳以上は保険対象外
      return true;
    }
    if (reservationData["2_dpt_ymd"] && reservationData["1_dpt_ymd"]) {
      // YYYYMMDD数値の生引き算だと月跨ぎで日数が跳ね上がる（例: 20260901-20260831+1=71）ため暦日で計算する
      const tripDays =
        this.moment(String(reservationData["2_dpt_ymd"]), "YYYYMMDD").diff(
          this.moment(String(reservationData["1_dpt_ymd"]), "YYYYMMDD"),
          "days"
        ) + 1;
      if (tripDays > this.appConfig.reservation.insuranceChuBbMaxDay) {
        //14泊以上は保険対象外
        return true;
      }
    }
    let cartData: any = this.cartService.getCartData();

    //往復は実際に選択された乗車地・降車地の都市が対称の場合のみ保険対象
    //（検索時に選んだ都市(serchData)は実際の乗降地の都市と異なることがあるため判定に使わない）
    if (!this._.isEmpty(cartData) && cartData.length > 1) {
      const rideCity0 = this._.get(cartData[0], [
        "plan",
        "station_list",
        cartData[0]["departure"],
        "town_id",
      ]);
      const dismountCity0 = this._.get(cartData[0], [
        "plan",
        "station_list",
        cartData[0]["destination"],
        "town_id",
      ]);
      const rideCity1 = this._.get(cartData[1], [
        "plan",
        "station_list",
        cartData[1]["departure"],
        "town_id",
      ]);
      const dismountCity1 = this._.get(cartData[1], [
        "plan",
        "station_list",
        cartData[1]["destination"],
        "town_id",
      ]);
      if (rideCity0 && dismountCity0 && rideCity1 && dismountCity1) {
        if (rideCity0 != dismountCity1 || dismountCity0 != rideCity1) {
          return true;
        }
      }
    }

    return false;
  }

  checkForcingPaymentByCreditCard(cartData: any) {
    let returnData = false;
    if (!this._.isEmpty(cartData)) {
      for (let item of cartData) {
        let remainingDepartureDay = this.moment(item.targetDay).diff(
          this.moment(),
          "hours"
        );
        if (remainingDepartureDay <= 24 && item.plan.force_credit_card_in_24h) {
          return true;
        }
      }
    }

    return returnData;
  }

  insertAndSubmitForm(htmlString: string) {
    // Veritrans 3DS判定:
    // Veritrans 3DS HTMLは <body onLoad="OnLoadEvent()"> + 複数form + inline scriptの
    // 多段処理が必要。innerHTML方式ではscriptが実行されず onLoad も発火しないため、
    // document.write で1枚のHTMLページとして描画する。
    // PayPayリダイレクト等の単純form HTMLは従来のinnerHTML方式で動作する。
    const isVeritrans3ds = /threeDsMethodForm|onLoad\s*=\s*"OnLoadEvent/i.test(htmlString);

    if (isVeritrans3ds) {
      // Veritrans 3DS: document.writeで全ページ描画
      // onLoad, inline script が全てブラウザネイティブで実行される
      document.open();
      document.write(htmlString);
      document.close();
    } else {
      // PayPayリダイレクト等: 従来のinnerHTML + form.submit方式
      const container = this.renderer.createElement("div");
      container.innerHTML = htmlString;
      const form = container.querySelector("form");
      if (form) {
        this.renderer.appendChild(document.body, form);
        form.submit();
      } else {
        console.error("No form found in the response HTML.");
      }
    }
  }
}
